import { dataAttributeProps } from '@pbk-web/utils';
import type { FC } from 'react';

import type IconProps from './IconProps';

const UnstableConnectionIcon: FC<IconProps> = (props) => {
  const { onClick, className } = props;
  const cursor = onClick ? 'cursor-pointer' : '';

  return (
    <svg
      {...dataAttributeProps(props)}
      onClick={onClick}
      className={`inline ${cursor} ${className}`}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1102 5.10625C17.451 4.9095 17.8894 5.02527 18.06 5.37984C18.8228 6.96454 19.1328 8.73467 18.948 10.493C18.7631 12.2514 18.0919 13.9184 17.0164 15.3099C16.7757 15.6212 16.3228 15.6433 16.0304 15.38C15.738 15.1167 15.7172 14.6679 15.9537 14.3534C16.8301 13.188 17.3774 11.803 17.5308 10.3441C17.6841 8.8851 17.4367 7.4166 16.8218 6.09448C16.6558 5.73768 16.7694 5.303 17.1102 5.10625Z"
        fill="#5A5766"
      />
      <path
        d="M1.8898 13.8938C1.54902 14.0905 1.11062 13.9747 0.939952 13.6202C0.177175 12.0355 -0.132768 10.2653 0.052042 8.50698C0.236852 6.74863 0.908053 5.08162 1.98364 3.69014C2.22429 3.37881 2.67719 3.35671 2.96961 3.62001C3.26204 3.88332 3.2828 4.33212 3.04629 4.64662C2.16988 5.81199 1.62258 7.19697 1.46924 8.65593C1.31589 10.1149 1.56328 11.5834 2.17824 12.9055C2.3442 13.2623 2.23059 13.697 1.8898 13.8938Z"
        fill="#5A5766"
      />
      <path
        d="M13.8938 17.1102C14.0905 17.451 13.9747 17.8894 13.6201 18.0601C11.9597 18.8593 10.0972 19.1606 8.26 18.9187C6.42278 18.6769 4.70178 17.9038 3.30474 16.702C3.00642 16.4454 3.00805 15.9919 3.2863 15.7137C3.56455 15.4355 4.01382 15.4382 4.31551 15.6909C5.48813 16.6729 6.9199 17.305 8.446 17.5059C9.97211 17.7068 11.5187 17.4668 12.9055 16.8218C13.2623 16.6558 13.697 16.7694 13.8938 17.1102Z"
        fill="#5A5766"
      />
      <path
        d="M5.10625 1.8898C4.9095 1.54902 5.02529 1.11061 5.37985 0.939944C7.04033 0.140687 8.90278 -0.1606 10.74 0.0812735C12.5772 0.323147 14.2982 1.0962 15.6953 2.29799C15.9936 2.55461 15.9919 3.00805 15.7137 3.2863C15.4354 3.56454 14.9862 3.56178 14.6845 3.30913C13.5119 2.32711 12.0801 1.695 10.554 1.49408C9.02789 1.29317 7.48131 1.53317 6.09448 2.17824C5.73768 2.3442 5.303 2.23058 5.10625 1.8898Z"
        fill="#5A5766"
      />
    </svg>
  );
};

export default UnstableConnectionIcon;
